import Vue from "vue";
import axios from "axios";
import moment from "moment";
let currentLang = JSON.parse(document.getElementById("langSite").innerHTML)
  .lang;
const lang = currentLang == "fr" ? "/" : `/${currentLang}/`;
const baseUrl = `${lang}wp-json/wp/v2`;

if (document.getElementById("vue-news")) {
  const categoryToExclude = document.getElementById("vue-news").dataset
    .category;
  new Vue({
    delimiters: ["[[", "]]"],
    async asyncData({ params, $http }) {
      const news = await $http.$get(`${baseUrl}/posts`);
      return { news };
    },
    el: "#vue-news",
    filters: {
      format(date) {
        return moment(date)
          .locale("fr")
          .format("DD.MM.YYYY");
      },
    },
    data() {
      return {
        isLoading: true,
        categories: [],
        origins: [],
        filters: {
          page: 1,
          per_page: 8,
          categories_exclude: null,
        },
        news: [],
        totalPages: null,
      };
    },
    computed: {
      hasMore() {
        return this.totalPages > this.news.length;
      },
    },
    created() {
      this.filters.categories_exclude = categoryToExclude;
      this.getNews();
    },
    mounted() {
      window.addEventListener(
        "hashchange",
        () => {
          this.filters.categories = Number(window.location.hash.substr(1));
          this.getNews();
        },
        false
      );
      this.getCategories();
      this.getOrigins();
      if (window.location.hash) {
        this.filters.categories = Number(window.location.hash.substr(1));
        this.getNews();
      }
    },
    methods: {
      deleteEmptyCategories(cat) {
        return cat.filter(
          (el) => el.count != 0 && el.slug != "faq" && el.count_origins != 0
        );
      },
      getCategories() {
        axios
          .request({
            method: "GET",
            url: `${baseUrl}/categories`,
            params: {
              per_page: 50,
            },
          })
          .then((response) => {
            this.categories = this.deleteEmptyCategories(response.data);
          });
      },
      getOrigins() {
        axios
          .request({
            method: "GET",
            url: `${baseUrl}/origins`,
            params: {
              per_page: 50,
            },
          })
          .then((response) => {
            this.origins = this.deleteEmptyCategories(response.data);
          });
      },
      getNews(more = false) {
        this.isLoading = true;
        axios
          .request({
            method: "GET",
            url: `${baseUrl}/posts`,
            data: this.form,
            headers: { "content-type": "application/json" },
            params: this.filters,
          })
          .then((response) => {
            this.news = more ? this.news.concat(response.data) : response.data;
            this.totalPages = response.headers["x-wp-total"];
            this.isLoading = false;
          })
          .catch((error) => {
            this.errors = Object.assign(this.errors, error.response.data);
          });
      },
      getMore() {
        this.filters.page++;
        this.getNews(true);
      },
      getCategory(category_id) {
        let category = this.categories.filter((obj) => obj.id === category_id);
        let categoryName = category.length > 0 ? category[0]["name"] : "";
        return categoryName;
      },
      getOrigin(origin_id) {
        let origin = this.origins.filter((obj) => obj.id === origin_id);
        let originName = origin.length > 0 ? origin[0]["name"] : "";
        return originName;
      },
      updateCategory(category) {
        this.news = [];
        this.filters.per_page = 8;
        this.filters.page = 1;
        this.filters.categories = category;
        this.filters.origins = undefined;
        this.getNews();
      },
      updateOrigin(origin) {
        this.news = [];
        this.filters.per_page = 8;
        this.filters.page = 1;
        this.filters.categories = undefined;
        this.filters.origins = origin;
        this.getNews();
      },
    },
  });
}
